<template>
  <tlbs-map ref="mapRef" api-key="XAUBZ-QGZC7-DCBXR-PDQ7T-MD4P7-7HBJ2" :center="center" :zoom="zoom" :control="control"
    @click="onClick" @map_inited="onMapInited">
    <div class="control-container">
      <button @click.stop="switchInfoWindow">
        {{ visible ? '关闭' : '开启' }}窗口
      </button>
    </div>
    <tlbs-info-window ref="infoWindowRef" :visible="visible" :position="center" :content="address" :options="{
      offset: {
        x: 0,
        y: 0,
      }
    }" />
  </tlbs-map>
</template>

<script>
export default {
  props: {
    postion: {}
  },
  name: 'InfoWindowDemo',
  data() {
    return {
      center: { lat: null, lng: null },
      address: '',
      zoom: 17,
      visible: true,
      control: {
        scale: {},
        zoom: {
          position: 'topRight'
        }
      }
    }
  },
  mounted() {
    let pos=this.postion;
    console.log(this.postion);
    console.log(this.postion.latitude);

    this.center = { lat: pos.latitude, lng: pos.longitude };
    this.address = pos.address;
    this.zoom = pos.zoom

  },
  methods: {
    onClick(e) {
      console.log(e);
    },
    switchInfoWindow() {
      this.visible = !this.visible;
    },
    onMapInited() {
      // 通过 $refs 访问组件实例
      console.log(this.$refs.mapRef.map);
      console.log(this.$refs.infoWindowRef.infoWindow);
    },
    getLayerInstance() {
      console.log(this.$refs.infoWindowRef.infoWindow);
    }
  }
}
</script>

<style scoped>
.control-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
}

button {
  padding: 4px;
  background-color: #fff;
  margin-right: 5px;
  border: 1px solid #ddd;
}
</style>